import {
  Box,
  Container,
  Divider,
  Grid,
  GridItem,
  Heading,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";

const EXPERIENCE = [
  {
    role: "Senior Software Engineer",
    location: "ReflexAI",
    link: "https://www.reflexai.com/",
    start: "February 2024",
    end: "Present",
    items: [],
  },
  {
    role: "Senior Software Engineer",
    location: "thinktum",
    link: "https://www.thinktum.ai/",
    start: "March 2023",
    end: "February 2024",
    items: ["I was assigned to lead a development team, where I played a key role in supporting and guiding each team member to achieve our common goals. I worked closely with each member, providing guidance and assistance to overcome technical challenges and reach project milestones. In addition to leading the team, I collaborated with other members to troubleshoot issues and provide additional support as needed. Throughout this process, I meticulously documented every aspect of the work, which will greatly facilitate future operations for the team. Additionally, I took on significant infrastructure responsibilities, using AWS and Terraform as infrastructure as code, to create new environments and infrastructure for new tenants, thus contributing to the project's expansion. This collaborative and supportive approach allowed me to play a more prominent role in strategic decision-making and overall project planning and execution, contributing to the achievement of both team and organizational objectives.I was assigned to lead a development team, where I played a key role in supporting and guiding each team member to achieve our common goals. I worked closely with each member, providing guidance and assistance to overcome technical challenges and reach project milestones. In addition to leading the team, I collaborated with other members to troubleshoot issues and provide additional support as needed. Throughout this process, I meticulously documented every aspect of the work, which will greatly facilitate future operations for the team. Additionally, I took on significant infrastructure responsibilities, using AWS and Terraform as infrastructure as code, to create new environments and infrastructure for new tenants, thus contributing to the project's expansion. This collaborative and supportive approach allowed me to play a more prominent role in strategic decision-making and overall project planning and execution, contributing to the achievement of both team and organizational objectives."],
  },
  {
    role: "Senior Software Engineer",
    location: "thinktum",
    link: "https://www.thinktum.ai/",
    start: "September 2022",
    end: "March 2023",
    items: ["Worked as a full stack developer, utilizing tools like React and Node.js. Additionally, I developed notification modules using Amazon SQS, integrated SignNow for document signing, and implemented an email sending module using Mandrill.Worked as a full stack developer, utilizing tools like React and Node.js. Additionally, I developed notification modules using Amazon SQS, integrated SignNow for document signing, and implemented an email sending module using Mandrill."],
  },
  {
    role: "Senior Technician Developer",
    location: "Endava",
    link: "https://www.endava.com/",
    start: "March 2022",
    end: "September 2022",
    items: ["My role involved the end-to-end development of web applications, encompassing both client and server-side aspects, leveraging a range of technologies including Node.js and React. Additionally, I ventured into mobile technologies such as Swift for native iOS apps and React Native for hybrid applications. Throughout my projects, I collaborated closely with fellow developers, designers, and stakeholders to conceive innovative solutions tailored to meet business needs."],
  },
  {
    role: "Software Engineer",
    location: "intive (SimTLiX)",
    link: "https://www.linkedin.com/company/intive",
    start: "September 2021",
    end: "March 2022",
    items: [
      "Worked as a developer at Cencosud, serving as the leader of the backend team and responsible for project architecture. Led refactoring efforts to implement best practices and SOLID design patterns. Utilized technologies including NestJS, React.js, TypeScript, and AWS. Additionally, contributed to infrastructure tasks."
    ],
  },
  {
    role: "Full Stack Mobile-Web Developer",
    location: "Spark Solutions",
    link: "https://www.linkedin.com/company/sparksolutions2/",
    start: "June 2021",
    end: "September 2021",
    items: [
      "I developed and uploaded to the PlayStore a similar Uber application for the municipality of San Nicolás de los Arroyos, using React Native, Redux, and Firebase with all its available tools. Additionally, I utilized React for the back office. Google Cloud and Firestore were employed for its development.",
    ],
  },
  {
    role: "Freelance",
    location: "Freelance",
    start: "July 2017",
    end: "June 2021",
    items: [
      "During my early experiences as a trainee developer, I led several projects from inception to implementation, focusing on ecommerce and management. I began with PHP and transitioned to a full JavaScript stack. As a freelancer, I honed my skills, developing applications swiftly and following industry best practices.",
    ],
  },
];

const EDUCATION = [
  {
    role: "Information Systems Engineering",
    location: "UTN VM",
    start: "2017",
    end: "Present",
    items: [],
  },
  {
    role: "Programmer Technician",
    location: "IPEM N°256",
    start: "2010",
    end: "2016",
    items: [],
  },
];

const ItemResume = ({ data, isLastItem }) => {
  return (
    <>
      <Box my={5}>
        <Heading size={"md"}>{data.role}</Heading>
        <Text fontSize={"md"}>
          {data.link ? (
            <Link href={data.link}>{data.location}</Link>
          ) : (
            data.location
          )}
        </Text>
        <Text fontSize={"sm"} opacity={0.8}>
          {data.start} - {data.end}
        </Text>
        <UnorderedList mt={5}>
          {data.items.map((item) => (
            <ListItem>{item}</ListItem>
          ))}
        </UnorderedList>
      </Box>
      {isLastItem && <Divider />}
    </>
  );
};

const Resume = () => {
  return (
    <Container maxW={"container.lg"}>
      <Heading mb={10}>Resume</Heading>
      <Grid templateColumns="repeat(12, 1fr)" gap={6}>
        <GridItem colSpan={[12,12,12, 8]}>
          <Heading size={"lg"}>Experience</Heading>
          {EXPERIENCE.map((data, key) => (
            <ItemResume
              data={data}
              isLastItem={key !== EXPERIENCE.length - 1}
            />
          ))}
        </GridItem>
        <GridItem colSpan={[12,12,12,4]}>
          <Heading size={"lg"}>Education</Heading>
          {EDUCATION.map((data, key) => (
            <ItemResume data={data} isLastItem={key !== EDUCATION.length - 1} />
          ))}
        </GridItem>
      </Grid>
    </Container>
  );
};

export default Resume;
